import { baseUrl } from 'client/Reports/constants/reportsConstants';
import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class ReportsApi extends CollectionApi {
  /**
   * @description Set up the api for getting admin role information.
   */
  constructor() {
    super('/api/v2/directoryinsights/reports', {
      skip: 0,
      limit: 10,
    });
  }

  async fetchReportsList(params) {
    await this.initialize();
    return axios.get(`${baseUrl}?${this.param(params)}`);
  }

  // Fetches reports from trino
  async generateReport(payload, route) {
    await this.initialize();
    return axios.post(`${this.baseUrl}/${route}`, payload);
  }

  // Fetches user to resource reports. Will be deprecated when
  // user to resource reports are standardized
  async fetchUsersToResourcesReport(payload, params) {
    await this.initialize();
    return axios.post(`${this.baseUrl}/users_to_resources?${this.param(params)}`, payload);
  }

  async downloadReport(reportObjectId, artifactObjectId) {
    await this.initialize();
    return axios.get(`${baseUrl}/${reportObjectId}/artifacts/${artifactObjectId}/content`);
  }
}

export default new ReportsApi();
